var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5845_163784)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5845_163784",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5845_163784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9721C0 5.35814 5.35814 0 11.9721 0C18.586 0 23.9442 5.35814 23.9442 11.9721C23.9442 18.586 18.586 23.9442 11.9721 23.9442C5.35814 23.9302 0 18.5721 0 11.9721Z",
    fill: "#5865F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3581 7.10174C16.3395 6.64128 15.2791 6.3064 14.1767 6.125C14.0372 6.37616 13.8837 6.69709 13.7721 6.96221C12.6 6.78081 11.4139 6.78081 10.2419 6.96221C10.1163 6.66919 9.97674 6.39012 9.82325 6.125C8.72093 6.3064 7.64651 6.64128 6.64186 7.1157C4.63256 10.1157 4.08837 13.032 4.35349 15.9203C5.53953 16.7994 6.85116 17.4692 8.26046 17.8878C8.58139 17.4552 8.86046 17.0087 9.09767 16.5343C8.63721 16.3669 8.20465 16.1576 7.78604 15.9064C7.89767 15.8227 7.99535 15.739 8.10697 15.6552C10.5767 16.8273 13.4512 16.8273 15.9209 15.6552C16.0326 15.739 16.1302 15.8227 16.2419 15.9064C15.8233 16.1576 15.3767 16.3669 14.9163 16.5343C15.1535 17.0087 15.4326 17.4552 15.7535 17.8878C17.1628 17.4552 18.4884 16.7994 19.6605 15.9203C19.9674 12.5715 19.1023 9.66919 17.3581 7.10174ZM9.43256 14.1343C8.66511 14.1343 8.05116 13.4366 8.05116 12.5855C8.05116 11.7343 8.66511 11.0227 9.43256 11.0227C10.214 11.0227 10.8279 11.7203 10.8279 12.5855C10.814 13.4366 10.214 14.1343 9.43256 14.1343ZM14.5674 14.1343C13.8 14.1343 13.186 13.4366 13.186 12.5855C13.186 11.7343 13.8 11.0227 14.5674 11.0227C15.3488 11.0227 15.9628 11.7203 15.9488 12.5855C15.9349 13.4506 15.3349 14.1343 14.5674 14.1343Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5845_163784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordIcon);
export default __webpack_public_path__ + "static/media/discord_icon.066196393a38e29d0703123fd43c10de.svg";
export { ForwardRef as ReactComponent };